import { ICreateEntregaObrasClienteUseCase } from "../../../presentation/useCases/create/create_entrega_obras_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateEntregaObrasClienteUseCase
 */

export class CreateEntregaObrasClienteUseCase implements ICreateEntregaObrasClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaObra: number,
    idClienteUnidade: number,
    idCentroCusto: number,
    idsChecklistEntrega: number[],
    clienteCadastrado?: boolean,
    descCliente?: string,
    tipoVistoriaCliente?: boolean,
    tipoVistoriaConstrutora?: boolean,
    localVistoria?: string,
    status?: number
  ): Promise<number> {
    return await this.repository.createEntregaObrasCliente(
      idEntregaObra,
      idClienteUnidade,
      idCentroCusto,
      idsChecklistEntrega,
      clienteCadastrado,
      descCliente,
      tipoVistoriaCliente,
      tipoVistoriaConstrutora,
      localVistoria,
      status
    );
  }
}
